var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lastGames)?_c('div',{staticClass:"d-block text-nowrap"},_vm._l((_vm.lastGames),function(g,index){return _c('span',{key:index,staticClass:"px-1 text-center",class:_vm.getClass(g)},[_vm._v(_vm._s(g)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }